export {};

// This is a way to safely adjust the date so that when it converts to an UTC string, it preserves the same exact date the original Date object represented.
// More information here: https://stackoverflow.com/questions/7403486/add-or-subtract-timezone-difference-to-javascript-date
Date.prototype.adjustForUTCSerialization = function (): Date {
  const copy = new Date(this);
  copy.setMinutes(copy.getMinutes() - copy.getTimezoneOffset());
  return copy;
};
